if (!customElements.get('rate-your-experience')) {
  customElements.define('rate-your-experience', class extends HTMLElement {
    connectedCallback() {
      this.stars = [...this.querySelectorAll('.rate-your-experience__star')];
      this.label = this.querySelector('.rate-your-experience__label');
      this.placeholder = this.label.textContent;
      this.highPanel = this.querySelector('[data-panel="high"]');
      this.lowPanel = this.querySelector('[data-panel="low"]');

      this.addEventListener('click', (event) => {
        const star = event.target.closest('.rate-your-experience__star');
        if (star) this.select(Number(star.dataset.rating));
        else if (event.target.closest('[data-reset]')) this.reset();
      });
    }

    disconnectedCallback() {
      this.stampedObserver?.disconnect();
    }

    select(rating) {
      this.stars.forEach((star, index) => {
        star.classList.toggle('is-on', index < rating);
        star.setAttribute('aria-pressed', String(index + 1 === rating));
      });
      this.label.textContent = this.stars[rating - 1].dataset.label;
      this.label.classList.remove('is-empty');

      const isHigh = rating >= 4;
      const panel = isHigh ? this.highPanel : this.lowPanel;
      (isHigh ? this.lowPanel : this.highPanel).hidden = true;
      panel.hidden = false;
      requestAnimationFrame(() => this.scrollToElement(panel));

      if (!isHigh) this.prefillStampedRating(rating);
    }

    reset() {
      this.stars.forEach((star) => {
        star.classList.remove('is-on');
        star.setAttribute('aria-pressed', 'false');
      });
      this.label.textContent = this.placeholder;
      this.label.classList.add('is-empty');
      this.highPanel.hidden = true;
      this.lowPanel.hidden = true;
      this.scrollToElement(this);
    }

    // Stamped renders its form asynchronously, so wait for its star inputs if they aren't there yet.
    prefillStampedRating(rating) {
      const form = this.lowPanel.querySelector('.rate-your-experience__form');
      const pick = () => {
        const options = form.querySelectorAll('.stamped-form-input.stamped-starrating a');
        if (options.length < rating) return false;
        options[rating - 1].click();
        return true;
      };

      this.stampedObserver?.disconnect();
      if (pick()) return;
      this.stampedObserver = new MutationObserver(() => {
        if (pick()) this.stampedObserver.disconnect();
      });
      this.stampedObserver.observe(form, { childList: true, subtree: true });
    }

    scrollToElement(element) {
      element.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    }
  });
}
